import React from 'react';

import { useGetPreviewPanelsActions } from '@atlassian/preview-panels-api';

import { PARENT_PRODUCTS } from '../common/constants';

import { ConfluencePagePreviewPanel } from './confluence-page-preview-panel';

export const useConfluencePagePreviewPanel = (
	title: string,
	url: string,
	parentProduct: (typeof PARENT_PRODUCTS)[keyof typeof PARENT_PRODUCTS],
) => {
	const { open, close } = useGetPreviewPanelsActions();

	const openConfluencePagePreviewPanel = () => {
		open({
			panel: {
				id: `confluence-page-preview-panel-${title}`,
				content: () => (
					<ConfluencePagePreviewPanel title={title} url={url} parentProduct={parentProduct} />
				),
			},
		});
	};

	const closeConfluencePagePreviewPanel = () => {
		const onClose = () => {};
		close(onClose);
	};

	return { openConfluencePagePreviewPanel, closeConfluencePagePreviewPanel };
};
